export default function TableOfContents({ content }) {
  if (!content) return null;

  const items = [
    { id: "introduction", label: "Introduction" },
    content.steps?.length && { id: "etapes", label: "Étapes à suivre" },
    content.price && { id: "prix", label: "Prix et coûts" },
    content.delays && { id: "delais", label: "Délais" },
    content.errors?.length && { id: "erreurs", label: "Erreurs à éviter" },
    content.faq?.length && { id: "faq", label: "FAQ" },
  ].filter(Boolean);

  return (
    <nav
      data-testid="table-of-contents"
      className="bg-white border border-slate-200 rounded-xl p-5"
      aria-label="Sommaire"
    >
      <h3 className="font-heading font-bold text-slate-900 text-sm uppercase tracking-wider mb-4">
        Sommaire
      </h3>
      <ol className="space-y-2">
        {items.map((item, idx) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              data-testid={`toc-link-${item.id}`}
              className="flex items-center gap-2 text-sm text-slate-600 hover:text-blue-600 transition-colors group"
            >
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-50 text-blue-600 text-xs font-bold flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors">
                {idx + 1}
              </span>
              {item.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
